import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { JobDefinitionsAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getJobDefinition = createAsyncThunk<JobDefinitionsAPI, number>(
  `${Slices.JOB_DEFINITION}/get`,
  async (definition_id, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get(`/job_definitions/${definition_id}`);
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
